import {
  ACTIONS,
  categories,
  labels,
} from '../helpers/analytics-utils/constants'
import trackEvent from '../helpers/analytics-utils/track-event'

type EventTracker = (category?: string, action?: string, label?: string) => void

export const createStoreClickTracker = (tracker: EventTracker) => (
  label: string
): void => {
  tracker(categories.NATIONAL, ACTIONS.clicked, labels.createStore(label))
}

export const createCategoryClickTracker = (tracker: EventTracker) => (
  label: string
): void => {
  tracker(categories.NATIONAL, ACTIONS.clicked, labels.createCategory(label))
}

export const createTheEditStoryClickTracker = (tracker: EventTracker) => (
  label: string
): void => {
  tracker(categories.THE_EDIT, ACTIONS.clicked, labels.STORY(label))
}

export const createTheEditDeckClickTracker = (tracker: EventTracker) => (
  label: string
): void => {
  tracker(categories.THE_EDIT_DECK, ACTIONS.clicked, labels.STORY(label))
}

export const storeClickTracker = createStoreClickTracker(trackEvent)
export const categoryClickTracker = createCategoryClickTracker(trackEvent)
export const storyClickTracker = createTheEditStoryClickTracker(trackEvent)
export const theEditDeckClickTracker = createTheEditDeckClickTracker(trackEvent)
